import { mapByIds } from '@wix/form-mapper';
import { applyItemPropertiesOverride } from './apply-item-properties-override';
import { evaluateOverrideConditionFactory } from './evaluate-override-condition';
import { asRequired, isFormRuleValid } from './utils';
export function applyOverrides(formSchema, submission) {
    const nestedForms = (formSchema?.nestedForms || []).flatMap(({ targets, form })=>(targets || []).map((target)=>({
                form: applyFormOverrides(asRequired(form), (submission || {})[target]),
                targets: [
                    target
                ]
            })));
    return {
        ...applyFormOverrides(formSchema, submission),
        nestedForms
    };
}
function applyFormOverrides(formSchema, submission) {
    const submissionsById = mapByIds(submission, formSchema);
    const { rules } = formSchema;
    if (rules) {
        return rules.filter((rule)=>isFormRuleValid(rule, formSchema)).filter((rule)=>evaluateOverrideConditionFactory()(rule, submissionsById)).reduce((form, rule)=>applyItemPropertiesOverride(form, rule), formSchema);
    }
    return formSchema;
}

//# sourceMappingURL=apply-overrides.js.map